import React from "react";
import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    margin: "5px",
    padding: "5px",
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    fontFamily: "Lato",
  },
  coverTitle: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  paragraph: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
  },
  secondSection:{
    // margin: 10,
     paddingTop: 10,
    borderRadius: 5,
    fontFamily: "Lato",
    backgroundColor: "#ffffff",
  },
  coverSecondTitle: {
    fontSize: 12,
    fontWeight: "700",
    color: "#426B88",
    lineHeight: "18px",
    fontFamily: "Lato",
    marginBottom: 10,
  },
  membersContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  memberColumn: {
    width: "50%",
  },
  memberText: {
    fontSize: 12,
    color: "#426B88",
    fontFamily: "Lato",
    fontWeight: "700",
    lineHeight: "18px",
    marginBottom: 5,
  },
});

export default function AboutGroupReportFirst() {
  return (
    <div>
      <View style={styles.coverSection}>
        <View>
          <Text style={styles.coverTitle}>ABOUT YOUR REPORT</Text>
          <Text style={styles.paragraph}>
            The QF Group report effectively combines up to 10 individual
            Quadrant Flow Self to provide you with an overview of individual and
            collective results. This group report is a tool to better understand
            your group and should be integrated thoughtfully into your
            development plans.
          </Text>
          <Text style={styles.paragraph}>
            Quadrant Flow encourages us to look beyond societal norms and
            explore the four dimensions of being human, empowering us to lead
            with wisdom and compassion in both personal and professional
            spheres.
          </Text>
          <Text style={styles.paragraph}>
            Quadrant Flow is a valid and reliable psychometric assessment but
            your results should be used as a starting point for discovery rather
            than conclusive judgment. Interpretations of the data can vary and
            may not be fully captured by the results. 
          </Text>
          <Text style={styles.paragraph}>
            For these reasons, it's highly recommended to review and interpret
            your Quadrant Flow assessment alongside a certified guide, coach,
            consultant, or trusted individual. This collaborative approach
            ensures that the insights gained are integrated thoughtfully into
            your personal and professional development plans.
          </Text>
          <Text style={styles.paragraph}>
            Remember, this report is a tool to aid in understanding yourself
            better, not a definitive measure of your capabilities or worth.
          </Text>
        </View>
        <View style={styles.secondSection}>
          <Text style={styles.coverSecondTitle}>GROUP MEMBERS:</Text>
          <View style={styles.membersContainer}>
            <View style={styles.memberColumn}>
              <Text style={styles.memberText}>1. Team Member1 Full Name</Text>
              <Text style={styles.memberText}>2. Team Member2 Full Name</Text>
              <Text style={styles.memberText}>3. Team Member3 Full Name</Text>
              <Text style={styles.memberText}>4. Team Member4 Full Name</Text>
              <Text style={styles.memberText}>5. Team Member5 Full Name</Text>
            </View>
            <View style={styles.memberColumn}>
              <Text style={styles.memberText}>6. Team Member6 Full Name</Text>
              <Text style={styles.memberText}>7. Team Member7 Full Name</Text>
              <Text style={styles.memberText}>8. Team Member8 Full Name</Text>
              <Text style={styles.memberText}>9. Team Member9 Full Name</Text>
              <Text style={styles.memberText}>10. Team Member10 Full Name</Text>
            </View>
          </View>
        </View>
      </View>
    </div>
  );
}
